import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

export const getVotingStatus = (votingStartAt, votingEndAt) => {
  const currentDate = new Date().toISOString();
  const now = dayjs(currentDate);
  const start = dayjs(new Date(votingStartAt).toString());
  const end = dayjs(new Date(votingEndAt).toString());
  if (votingStartAt === null) {
    return "no dates";
  } else if (now.isSameOrBefore(start, "millisecond")) {
    return "not started";
  } else if (now.isSameOrAfter(end, "millisecond")) {
    return "ended";
  } else {
    return "active";
  }
};
